export enum  NotificationConsts {
    SUIVI_PORTFEUILLE_IMPORTATION = 'SUIVI_PORTFEUILLE_IMPORTATION',
    ANOTHER_CONSTANT = 'ANOTHER_CONSTANT',
    NOUVELLE_TACHE = 'NOUVELLE_TACHE'
  }
  